import React from 'react';
import { Trans } from 'react-i18next';
import { IInviteMessage } from '../InviteMembersModal.d';
import isMobile from '../../../utils/isMobile';
import TrackLink from '../../../utils/trackLink';

const MessengerButton = ({
  shareURL,
  fbAppId,
}: // eslint-disable-next-line no-shadow
Pick<IInviteMessage, 'shareURL' | 'fbAppId'>) => {
  const fbHref = isMobile(window)
    ? `fb-messenger://share?link=${encodeURIComponent(
        shareURL,
      )}&app_id=${encodeURIComponent(fbAppId)}`
    : `http://www.facebook.com/dialog/send?app_id=${fbAppId}&link=${shareURL}&redirect_uri=${shareURL}`;
  return (
    <TrackLink
      className="jg-btn jg-btn--messenger jg-h4 jg-space-mbms"
      href={fbHref}
      target="_blank"
      rel="noopener noreferrer"
      trackingData={{
        action_name: 'link click',
        subtype: 'invite',
        event: 'link click',
        event_value: 'messenger',
        page_section: 'invite team members',
      }}
    >
      <Trans i18nKey="share.button.messenger" />
    </TrackLink>
  );
};
export default MessengerButton;
